export const nonFlowServices = numbers =>
  numbers.numbers
    .map(numberId => numbers.numbersById[numberId])
    .filter(
      number =>
        !(
          number &&
          number.usagePlan &&
          number.usagePlan.startsWith('Flows-') &&
          number.twilioFlowServiceId
        )
    )

/**
 * Returns the numbers which are related to flows
 * Does not include the twilio linked numbers
 */
export const flowServices = numbers =>
  numbers.numbers
    .map(numberId => numbers.numbersById[numberId])
    .filter(number => {
      if (number && number.usagePlan && number.usagePlan.startsWith('Flows-')) {
        return !number.twilioFlowServiceId
      }
      return number.twilioFlowServiceId
    })

export const mobileServices = numbers =>
  numbers.numbers
    .map(numberId => numbers.numbersById[numberId])
    .filter(number => number && number.twilioCapabilities.SMS)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Numbers/Numbers.utils.js